export default "__VITE_ASSET__CiLBoddl__"